import {createI18n} from 'vue-i18n';

const messages = {
  en: {
    menu: {
      home: 'Home', sign_in: 'Sign In', cabinet: 'Cabinet',
    },

    home: {
      line_1: 'Standalone intuitive orders manager',
      start_btn: 'Start with Ebics API',
    },

    sign_in: {
      title: 'Sign In',
      line_1: 'Use dashboard to control access',
      github_btn: 'GitHub sign in',
      openid_btn: 'OpenId sign in',
    },

    fetch: {
      authorize: 'Authorize by {name}',
    },
  },

  de: {
    menu: {
      home: 'Startseite', sign_in: 'Anmelden', cabinet: 'Kabinett',
    },

    home: {
      line_1: 'Eigenständiger, intuitiver Auftragsmanager',
      start_btn: 'Starten Sie mit der Ebics API',
    },

    sign_in: {
      title: 'Anmelden',
      line_1: 'Verwenden Sie das Dashboard, um den Zugriff zu steuern',
      github_btn: 'Mit GitHub anmelden',
      openid_btn: 'Mit OpenId anmelden',
    },

    fetch: {
      authorize: 'Autorisieren durch {name}',
    },
  },

  fr: {
    menu: {
      home: 'Accueil', sign_in: 'Connexion', cabinet: 'Cabinet',
    },

    home: {
      line_1: 'Gestionnaire de commandes autonome et intuitif',
      start_btn: 'Commencer avec l`API Ebics',
    },

    sign_in: {
      title: 'Se connecter',
      line_1: 'Utilisez le tableau de bord pour contrôler l`accès',
      github_btn: 'Se connecter avec GitHub',
      openid_btn: 'Se connecter avec OpenId',
    },

    fetch: {
      authorize: 'Autoriser par {name}',
    },
  },
};

export default createI18n({locale: 'en', fallbackLocale: 'en', messages, legacy: false, globalInjection: false});
